/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IVerifyPasswordResetRequest {
  email?: null | string;
}
export class VerifyPasswordResetRequest extends BaseModel implements IVerifyPasswordResetRequest {
  email?: null | string;
}

